// 正则判断
function testPhone(str) {
  if (str.length != 11) {
    return false;
  }
  var myreg = /^((1)+\d{10})$/;

  return myreg.test(str);
}

function testEmail(str) {

  var myreg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

  return myreg.test(str);
}

function testIDcard(str) {
  if (str.length == 18) {
    var myreg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    return myreg.test(str);
  } else if (str.length == 15) {
    var myreg = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
    return myreg.test(str);
  } else {
    return false
  }
}

function testPassword(str) {
  if (str.length >= 10 && str.length <= 18) {
    var myreg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~$@$!%*#?&])[A-Za-z\d~$@$!%*#?&]{10,18}$/
    return myreg.test(str);
  }else {
    return false
  }
}

// 设置cockie
function setCookie(name, value, day = 0) {
  if (day !== 0) { //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
    var expires = day * 24 * 60 * 60 * 1000;
    var date = new Date(+new Date() + expires);
    document.cookie = name + "=" + escape(value) + ";expires=" + date.toUTCString();
  } else {
    document.cookie = name + "=" + escape(value);
  }
};
// 读取cookie
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

export {
  testPhone,
  testIDcard,
  testPassword,
  setCookie,
  getCookie,
  testEmail
}



// WEBPACK FOOTER //
// ./src/common/util.js